import React, { ChangeEvent, useState } from "react";
import { Role, User } from "../common/ObjectTypes";
import { Link } from "react-router-dom";
import tailwindClassnames from "../common/TaildwindClassnames";
import TextInput from "../common/TextInput";
import Pagination from "../common/Pagination";

type UsersListTypes = {
  users: User[];
  roles: Role[];
  organizations: any[];
  onSelectUser: (id: string) => void;
  onClickAdd: () => void;
  searchQuery: any;
  pageCount: number;
  pageSize: number;
  totalCount: number;
  handlePageClick: (selectedItem: { selected: number }) => void;
  reloadPage: boolean;
  recordStart: number;
  recordEnd: number;
  loading: boolean;
};

const UsersList = ({
  users,
  roles,
  organizations,
  onSelectUser,
  handlePageClick,
  reloadPage,
  pageCount,
  totalCount,
  recordStart,
  recordEnd,
  searchQuery,
  loading,
}: UsersListTypes) => {
  return (
    <div className="p-6">
      {/* List */}
      <div className="flex flex-row justify-between">
        <h1 className={tailwindClassnames.tableTitle}>Users</h1>
      </div>

      <div className="flex flex-row items-center justify-end mt-4">
        {/* <div className="flex flex-row mr-auto w-1/3">
          <TextInput
            name=""
            label=""
            onChange={() => console.log("onSearch()")}
            value={""}
            placeholder="Filter by name"
            error={null}
            initialFocus={false}
            className={tailwindClassnames.searchTextInput}
            disabled={false}
            type=""
            onKeyPress={() => {}}
          />
          <button
            onClick={() => {}}
            className={tailwindClassnames.searchButton}
          >
            Search
          </button>
        </div> */}
        <div className="flex justify-end">
          <Link to="/user/add" className={tailwindClassnames.lookupButton}>
            Add
          </Link>
        </div>
      </div>
      {/* List */}
      <table className={tailwindClassnames.tableContainer}>
        <thead className={tailwindClassnames.tableHead}>
          <tr>
            <th className={tailwindClassnames.tableHeadText}>Name</th>
            <th className={tailwindClassnames.tableHeadText}>Username</th>
            <th className={tailwindClassnames.tableHeadText}>Roles</th>
            <th className={tailwindClassnames.tableHeadText}>Organization</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user: User, index: number) => {
            const rowClass =
              index % 2 === 0 ? "bg-grayScale-200" : "bg-grayScale-100";
            return (
              <tr
                key={user.userId}
                className={rowClass + tailwindClassnames.tableBody}
                onClick={() => onSelectUser(user.userId)}
              >
                <td className={tailwindClassnames.tableBodyText}>
                  {user.firstName + " " + user.lastName}
                </td>
                <td className={tailwindClassnames.tableBodyText}>
                  {user.userName}
                </td>
                <td className={tailwindClassnames.tableBodyText}>
                  {user.roles.map((role: Role, index: number) => (
                    <span key={role.roleId}>
                      {role.name}
                      {index < user.roles.length - 1 && ", "}
                    </span>
                  ))}
                </td>
                <td className={tailwindClassnames.tableBodyText}>
                  {user.organizations.map((org) => (
                    <span key={org.organizationId}>{org.name}</span>
                  ))}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <Pagination
        handlePageClick={handlePageClick}
        pageCount={pageCount}
        loading={loading}
        recordStart={recordStart}
        recordEnd={recordEnd}
        totalCount={totalCount}
        pageSize={searchQuery.pageSize}
        selectPage={false}
        searchQuery={searchQuery}
      />
    </div>
  );
};

export default UsersList;
